<template>
  <rid-fatture-clienti-in-scadenza />
</template>

<script>
import RidFattureClientiInScadenza from '@/components/ask/pages/RidFattureClientiInScadenza.vue'

export default {
  name: 'PageRidFattureClientiInScadenza',

  components:{
    RidFattureClientiInScadenza
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
